import { OverviewController } from '../controller/OverviewController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class OverviewWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: OverviewController,
    });
  }
}
